import { ADD_TAB, CLOSE_TAB, SET_ACTIVE_TAB, CLOSE_ALL_TABS } from "../types/type";

export const addTab = (tab) => ({
  type: ADD_TAB,
  payload: tab,
});

export const setActiveTab =  (index) => ({
  type: SET_ACTIVE_TAB,
  payload: index,
});

export const closeTab = (index) => ({
  type: CLOSE_TAB,
  payload: index,
});

export const closeAllTabs = () => ({
  type: CLOSE_ALL_TABS
});
